/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ liters: NonNullable<unknown> }} Care_Log_Quantity_Hint_LiterInputs */

const vi_care_log_quantity_hint_liter = /** @type {(inputs: Care_Log_Quantity_Hint_LiterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~ ${i?.liters} lít`)
};

/**

* @param {Care_Log_Quantity_Hint_LiterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_quantity_hint_liter = /** @type {((inputs: Care_Log_Quantity_Hint_LiterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Quantity_Hint_LiterInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_quantity_hint_liter(inputs)
});